var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"257px"}},[_c('a-select',{staticClass:"ts-w-full",attrs:{"showSearch":"","mode":"multiple","optionFilterProp":"children","loading":_vm.loading,"maxTagTextLength":17,"maxTagCount":1,"placeholder":_vm.showPlaceholder ? _vm.$t('location_filter') : null,"options":_vm.options.map(el => ({
          value: el.location_id,
          label: el.location_name_en
        })),"filterOption":(input, option) =>
          option.componentOptions.children[0].text
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0},on:{"change":_vm.changeValue},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }